/** Strips "$", commas and whitespace from a money string, e.g. "$62,269.00" -> "62269.00". */
export function cleanMoneyString(value: string): string {
  return value.replace(/[$,\s]/g, '');
}

/** Parses a money string that may contain "$" or commas; returns 0 for empty or invalid input. */
export function parseMoney(value: string | number | undefined | null): number {
  if (typeof value === 'number') return isNaN(value) ? 0 : value;
  if (!value) return 0;
  const num = parseFloat(cleanMoneyString(value));
  return isNaN(num) ? 0 : num;
}

export function formatMoney(amount: number | string | undefined): string {
  if (amount === undefined || amount === null) return '$0.00';
  const numAmount = typeof amount === 'string' ? parseMoney(amount) : amount;
  return numAmount.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatPhoneNumber(phoneNumber: string) {
  // Clean the phone number to only contain digits
  const cleaned = phoneNumber.replace(/\D/g, '');

  // Check if we have a valid 10-digit number
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }

  // Return original if not a 10-digit number
  return phoneNumber;
}

export function formatDate(timestamp: number): string {
  return new Date(timestamp).toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
}
